/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import { observer } from 'mobx-react';

import FieldButton from './FieldButton';

import './fieldsList.scss';

@observer
class FieldsList extends Component {

	constructor(props) {
		super(props);
		this.fieldsListRef = React.createRef();
	}

	_onButtonClick(index) {
		if (this.props.onSelectField) {
			this.props.onSelectField(this.props.fields[index]);
		}
	}
	_onDeleteField(index) {
		if (this.props.onDeleteField) {
			this.props.onDeleteField(this.props.fields[index]);
		}
	}

	render() {
		if(this.props.error) {
			return this._renderError();
		}

		return (
			<div className='fieldsListContainer'>
				{
					this.props.title && (
						<div className='fieldsListTitle'>
							{this.props.title}
						</div>
					)
				}
				<div className='fieldsList'
					onKeyDown={(e) => this._onKeyDown(e)}
					ref={this.fieldsListRef}
				>
					{
						this.props.fields.map(
							(field, i) => {
								const deletable = !!field.deletable;
								const onDelete = deletable ? this._onDeleteField.bind(this, i) : null;
								return (
									<FieldButton
										deletable={deletable}
										onDelete={onDelete}
										key={i}
										id={field.id}
										label={field.label}
										onClick={()=>this._onButtonClick(i)}
										activeDataSourceModule={this.props.activeDataSourceModule}
										shouldUseDisambiguatedPaths={this.props.shouldUseDisambiguatedPaths}
									/>
								);
							}
						)
					}
				</div>
			</div>
		);
	}

	_renderError(error = this.props.error) {
		return (
			<div className='fieldsListContainer'>
				<div className='fieldsListTitle'>{error.title}</div>
				<div className='fieldsListErrorMessage'>{error.description}</div>
			</div>
		);
	}


	_getFieldListNode() {
		return this.fieldsListRef.current;
	}
	_onKeyDown(event) {
		const fieldsListNode = this._getFieldListNode();
		const index = this.props.fields.findIndex((field) => field.id === event.target.id);
		if (index !== -1) {
			switch (event.key) {
				case 'ArrowLeft':
					if (index > 0) {
						this._setButtonTabIndex(fieldsListNode, index - 1, '0');
						this._focusFieldButtonNode(fieldsListNode, index - 1);
						this._blurFieldButtonNode(fieldsListNode, index);
					}
					event.preventDefault();
					break;
				case 'ArrowRight':
					if (index < this.props.fields.length - 1) {
						this._setButtonTabIndex(fieldsListNode, index + 1, '0');
						this._focusFieldButtonNode(fieldsListNode, index + 1);
						this._blurFieldButtonNode(fieldsListNode, index);
					}
					event.preventDefault();
					break;
				case 'Tab':
					for(let i = 0; i <= this.props.fields.length - 1; i++) {
						if (i !== index) {
							this._setButtonTabIndex(fieldsListNode, i, '-1');
						}
					}
					this._blurFieldButtonNode(fieldsListNode, index);
					break;
				default:
					break;
			}
		}
	}
	_setButtonTabIndex(fieldsListNode, index, tabIndex) {
		fieldsListNode.children[index].children[0].tabIndex = tabIndex;
	}
	_getButtonNode(listNode, index) {
		return listNode.children[index].children[0];
	}
	_blurFieldButtonNode(listNode, index) {
		const node = this._getButtonNode(listNode, index);
		node.blur();
		node.classList.remove('is-active');
		node.classList.remove('is-focus');
	}
	_focusFieldButtonNode(listNode, index) {
		const node = this._getButtonNode(listNode, index);
		node.focus();
		node.classList.add('is-focus');

	}
}

FieldsList.propTypes = {
	fields: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.string,
		label: PropTypes.string,
		deletable: PropTypes.bool
	})),
	error: PropTypes.shape({
		title: PropTypes.string,
		description: PropTypes.string
	}),
	onSelectField: PropTypes.func,
	onDeleteField: PropTypes.func,
	title: PropTypes.string,
	activeDataSourceModule: PropTypes.observableObject,
	shouldUseDisambiguatedPaths: PropTypes.bool,
	relationshipVM: PropTypes.observableObject.isRequired
};

export default FieldsList;



// WEBPACK FOOTER //
// ./src/js/components/fieldsList/FieldsList.js